<template>
  <div id="app" class="flex-col">
    <header :class="idOrangeTheme ? 'theme-orange' : ''">
      <div class="header-content">
        <img
            class="header-content-logo"
            :src="require('@/assets/img/logo_x2.png')"
            @click="clickHome"
            alt=""
        >
        <div class="header-content-tab">
          <div
              class="header-content-tab-item"
              @click="clickHome"
              :class="activeID === '0'? 'active' : ''"
          >
            首页
          </div>
          <div
              v-for="item in tabList"
              :key="item.id"
              class="header-content-tab-item"
              :class="activeID === item.id? 'active' : ''"
              @click="handleClick(item)"
          >
            {{ item.channelName }}
          </div>
          <el-dropdown v-if="tabListMore.length>0" trigger="click" @command="handleClick">
						<span class="el-dropdown-link" :class="activeID === 4? 'active': ''">
							更多<i class="el-icon-caret-bottom el-icon--right"></i>
						</span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="item in tabListMore" :key="item.id" :command="item">{{
                  item.channelName
                }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <!-- <img class="header-content-tab-img" :src="require('@/assets/icon/hot_x2.png')" alt="">
<span class="header-content-tab-txt" @click="toPointsMall">积分商城</span> -->
        </div>
        <div class="flex-1" />
        <div class="header-search flex-row">
          <div class="header-search__select flex-row flex-center">
            <el-dropdown trigger="click" @command="item => selectVal = item">
              <p style="color: #fff; cursor: pointer">
                {{ ['全部', '积分商城', '会员专区', '机构'][selectVal] }}
                <i class="el-icon-caret-bottom el-icon--right" style="color: rgba(255, 255, 255, 0.4)"></i>
              </p>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="0">全部</el-dropdown-item>
                <el-dropdown-item command="1">积分商城</el-dropdown-item>
                <el-dropdown-item command="2">会员专区</el-dropdown-item>
                <el-dropdown-item command="3">机构</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="flex-1">
            <input
                class="header-search__input"
                v-model.trim="searchVal"
                placeholder="请输入关键词"
                @keydown.enter="onSearch"
            />
          </div>
          <i @click="onSearch" class="header-search__icon el-icon-search"></i>
        </div>
        <div class="header-menus flex-row">
          <div @click="toPointsMall" class="header-menus__menu flex-row flex-center">
            <img class="header-menus__menu-icon" :src="require('@/assets/icon/hot_x2.png')" alt="">
            积分商城
          </div>
          <div @click="toVipDetail" class="header-menus__menu flex-row flex-center">
            <img class="header-menus__menu-icon" :src="require('@/assets/icon/hot_x2.png')" alt="">
            会员专区
          </div>
          <div class="header-menus__menu flex-row flex-center">
            <el-dropdown v-if="$store.state.user.id" @command="onCommand">
              <img class="user-avatar" v-if="$store.state.user.headUrl"
                   :src="'https://lms-res-static.ouchn.cn/' + $store.state.user.headUrl" alt="">
              <img class="user-avatar" v-else :src="require('@/assets/img/avatar-0.png')" alt="">
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="/my">个人中心</el-dropdown-item>
                <el-dropdown-item command="/my?component=p-my-collection">我的收藏</el-dropdown-item>
                <el-dropdown-item command="">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <template v-else>
<!--              <span style="cursor: pointer" @click="onShowLoginModal">登录</span>-->
<!--              <el-divider direction="vertical"></el-divider>-->
              <span style="cursor: pointer" @click="toLogin">登录</span>
              <el-divider direction="vertical"></el-divider>
              <span style="cursor: pointer" @click="onRegisteredModal">注册</span>
            </template>
          </div>
        </div>
      </div>
    </header>

    <!-- <main>
  <router-view />
</main> -->
    <div class="content flex-1">
      <router-view />
    </div>

    <footer>
      <div class="footer-content">
        <img class="footer__logo" :src="require('@/assets/img/logo_x2.png')" alt="">
        <div class="footer-copyright">
          <a href="https://beian.miit.gov.cn/#/Integrated/index">京ICP备05064925号-6</a>
          <div class="footer__split" />
          <a href="https://beian.miit.gov.cn/#/Integrated/index">
            <img class="police" :src="require('@/assets/icon/police.png')" alt="">
            京公网安备
          </a>
          <div class="flex-1" />
          <p>国家开放大学版权所有</p>
          <div class="footer__split" />
          <router-link tag="p" style="cursor: pointer" to="alliance"><a>共享联盟</a></router-link>
        </div>
      </div>
<!--      <div class="footer-content">-->
<!--        <div class="footer-copyright">-->
<!--          <div style="display: flex;justify-content: space-between;">-->
<!--            <div style="display: flex;align-items: center;">-->
<!--              <img class="footer-map-logo" style="width: 30px" src="@/assets/icon/logo.png">-->
<!--              <a href="https://beian.miit.gov.cn/#/Integrated/index">京ICP备05064925号-6</a> <span-->
<!--                class="divider"></span>-->
<!--              <a href="https://beian.miit.gov.cn/#/Integrated/index"> <img class="police"-->
<!--                                                                           :src="require('@/assets/icon/police.png')"-->
<!--                                                                           alt=""> 京公网安备-->
<!--                11040202430135号</a>-->
<!--            </div>-->
<!--            <div>-->
<!--              <span class="footer-span">国家开放大学版权所有</span>-->
<!--              <span class="divider"></span>-->
<!--              <span>-->
<!--								<router-link tag="span" style="cursor: pointer" to="alliance"><a>共享联盟</a></router-link>-->
<!--							</span>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
    </footer>
    <!-- 登录弹窗 -->
    <div v-if="showLoginModal" class="g-modal flex-col flex-center" @click="onHideModal">
      <div class="g-modal__main" @click.stop>
        <div class="g-modal__tabs flex-row mb-20">
          <div class="g-modal__tab g-modal__tab--active flex-col">
            帐号登录
            <div class="g-modal__tab-line" />
          </div>
          <!--     未看到有接口     -->
          <!--          <div class="g-modal__tab flex-col">-->
          <!--            短信登录-->
          <!--            <div class="g-modal__tab-line" />-->
          <!--          </div>-->
        </div>
        <el-form :model="loginForm" :rules="loginFormRule" status-icon ref="loginForm">
          <el-form-item prop="username">
            <el-input v-model="loginForm.username" placeholder="用户名">
              <template v-slot:prefix>
                <img class="g-modal__icon" :src="require('@/assets/icon/loginUser.png')" alt="">
              </template>
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input type="password" v-model="loginForm.password" placeholder="密码">
              <template v-slot:prefix>
                <img class="g-modal__icon" :src="require('@/assets/icon/loginPwd.png')" alt="">
              </template>
            </el-input>
          </el-form-item>
          <el-form-item prop="captcha">
            <el-input class="g-model__captcha-input" v-model="loginForm.captcha" placeholder="验证码"
                      @keydown.enter.native="onLogin">
              <template v-slot:prefix>
                <img class="g-modal__icon" :src="require('@/assets/icon/loginCode.png')" alt="">
              </template>
            </el-input>
            <img class="g-model__captcha" :src="captchaPath" alt="" @click="getCaptcha">
          </el-form-item>
        </el-form>
        <el-button type="primary" style="width: 100%;" :loading="load.login" @click="onLogin">
          <span style="color: #fff;">登录</span>
        </el-button>
        <!--        <button class="g-modal__btn g-modal__btn&#45;&#45;confirm" @click="onLogin">登录</button>-->
        <!--        <button class="g-modal__btn g-modal__btn&#45;&#45;default" style="margin-top: 10px;">注册</button>-->
      </div>
    </div>
    <!-- 支付方式 -->
    <el-dialog title="请选择支付方式" custom-class="pay-dialog" :visible.sync="showPayModal" :close-on-click-modal="false"
               :width="payModalWidth" @close="onHidePayModal">
      <ul class="pay-list flex-row" v-loading="payList.length === 0">
        <li v-for="pay in payList" :key="pay.type"
            :class="['pay-item', payList.length <= 3 ? 'pay-item--3' : 'pay-item--4']">
          <div :class="['pay flex-col flex-center', { 'pay--active': currentPayMethod === pay.type }]"
               @click="currentPayMethod = pay.type">
            <div class="pay__main flex-row">
              <img class="pay__icon" :src="pay.icon"
                   :style="pay.tip ? { width: '18px', height: '18px' } : {}" alt="">
              <span class="pay__label">{{ pay.name }}</span>
            </div>
            <p v-if="pay.tip" class="pay__tip">{{ pay.tip }}</p>
          </div>
          <div class="pay__warning">
            <template v-if="pay.warn && currentPayMethod === pay.type">
              <i class="el-icon-warning-outline"></i>
              {{ pay.warn }}
            </template>
          </div>
        </li>
      </ul>
      <template v-if="currentPayMethod === PAY.Integral.type">
        <p class="pay-integral">兑换积分：<span class="pay-integral__num">{{ payConfig.order.point }}</span></p>
        <div class="pay-modal-footer">
          <el-button size="mini" @click="onHidePayModal">取消</el-button>
          <el-button type="danger" size="mini" @click="onPay()" :loading="loadPay"
                     :disabled="points < payConfig.order.point">
            <span style="color: #fff">兑换</span>
          </el-button>
        </div>
      </template>
      <template v-else>
        <p class="pay-integral">实付金额：<span class="pay-integral__num">￥{{ orderPrice }}</span>
        </p>
        <div class="pay-modal-footer">
          <el-button size="mini" @click="onHidePayModal">取消</el-button>
          <el-button id="zeng" type="danger" size="mini" :loading="loadPay" @click="onPay()">
            <span style="color: #fff">支付</span>
          </el-button>
        </div>
      </template>
    </el-dialog>
    <!-- 使用 slot 的方式，会出现 偏移 -->
    <el-popover ref="popover" placement="bottom" width="240" trigger="click">
      <div class="stop-click" @click.stop v-if="currentPayMethod" style="text-align: center">
        <p class="popover-title">{{ PAY[currentPayMethod].text }}支付￥{{ orderPrice }}</p>
        <!--                <div class="popover-cover flex-col flex-center" style="text-align: center">-->
        <!--                    此环境不支持二维码支付，请点击下方文字进行支付-->
        <!--                </div>-->
        <!-- 正式环境放开 -->
        <vue-qr class="popover-cover" :size="500" :text="qr" :margin="0" />
        <p class="popover-tip">{{
            currentPayMethod === PAY.UnionPay.type ? '使用微信,支付宝,银联扫描二维码支付' : `使用${PAY[currentPayMethod].text}扫描二维码支付`
          }}</p>
        <!--                <p class="popover-tip" @click="onDevAliPay" style="cursor: pointer">点我进行跳转支付</p>-->
      </div>
    </el-popover>
    <!-- 积分兑换，选择地址形式 -->
    <el-dialog custom-class="integral-dialog" :close-on-click-modal="false" :visible.sync="integralModal.show"
               title="积分兑换" top="8vh">
      <div class="p-mall-dialog__order flex-row">
        <img class="p-mall-dialog__order-cover" :src="$api.staticUrl + integralModal.order.imgUrl" alt="">
        <div class="p-mall-dialog__order-main flex-1">
          <p class="p-mall-dialog__order-name ellipsis-1">{{ integralModal.order.goodsName }}</p>
          <div style="height: 32px">
            <p class="p-mall-dialog__order-desc ellipsis-2">{{ integralModal.order.goodsDes }}</p>
          </div>
          <div class="p-mall-dialog__order-integral flex-1 flex-row">
            <img class="p-mall-dialog__order-integral-icon" :src="require('@/assets/icon/integral.png')"
                 alt="">
            <span class="p-mall-dialog__order-integral-number">
							{{ integralModal.order.point }}<span class="p-mall-dialog__order-integral-tip">积分</span>
						</span>
            <div class="flex-1" />
            <p class="p-mall-dialog__order-tip">积分商品不支持退换</p>
          </div>
        </div>
      </div>
      <div class="p-mall-dialog__check-address flex-row">
        <p class="p-mall-dialog__check-address-text">选择收货地址</p>
        <el-popover placement="bottom-end" width="408" trigger="click" v-model="showIntegralPopover"
                    popper-class="points-mall">
          <el-form :model="integralModal.form" :rules="integralModalRules" label-width="80px"
                   label-position="left" ref="modalForm" size="small">
            <el-form-item label="姓名" prop="userName">
              <el-input placeholder="请输入姓名" v-model.trim="integralModal.form.userName" />
            </el-form-item>
            <el-form-item label="电话" prop="userTel">
              <el-input placeholder="请输入电话" v-model="integralModal.form.userTel" />
            </el-form-item>
            <el-form-item label="所在区域" prop="userRegion">
              <el-cascader filterable style="width: 100%" :options="addressOptions"
                           :props="{ value: 'name', label: 'name' }" v-model="addressSelectValue" />
            </el-form-item>
            <el-form-item label="详细地址" prop="userAddress">
              <el-input type="textarea" v-model="integralModal.form.userAddress" :rows="5"
                        placeholder="请输入详细地址" />
            </el-form-item>
            <el-form-item label="">
              <el-button type="primary" size="mini" @click="onIntegralConfirmForm"
                         :loading="integralLoad.form"><span style="color: #fff">添加</span></el-button>
              <el-button size="mini" @click="showIntegralPopover = false">取消</el-button>
            </el-form-item>
          </el-form>
          <el-button slot="reference" type="text">
            <i style="color: #3355FF" class="el-icon-plus"></i>
            <span style="color: #3355FF">添加收货地址</span>
          </el-button>
        </el-popover>
      </div>
      <div class="p-mall-dialog__address-list flex-col">
        <el-radio v-for="address in addressList" :key="address.id" v-model="addressStr" :label="address.id"
                  border
                  @change="integralModal.address = { buyerName: address.userName, buyerTel: address.userTel, receiveAddress: address.allAddress }">
          <div class="flex-row" style="flex-wrap: wrap; align-items: center">
						<span class="p-mall-dialog__address-user">
							{{ address.userName }}<span
                class="p-mall-dialog__address-phone">{{ address.userTel }}</span>
						</span>
            <div v-if="address.defaultType" class="p-my-address__tag">默认地址</div>
            <p class="p-mall-dialog__address-text" style="width: 100%">{{
                address.userRegion + ' ' +
                address.userAddress
              }}</p>
          </div>
        </el-radio>
        <div class="p-mall-dialog__empty" v-if="addressList.length === 0">
          <img class="p-mall-dialog__empty-icon" :src="require('@/assets/img/emptyIcon.png')" alt="">
          <p class="p-mall-dialog__empty-text">暂无收货地址，请添加收货地址</p>
        </div>
      </div>
      <div class="dialog-footer">
        <el-button size="mini" @click="onHideIntegralModal">取消</el-button>
        <el-button type="primary" size="mini" @click="onExchangeIntegral(integralModal.order)"
                   :loading="integralLoad.buy[integralModal.order.id]"><span
            style="color: #fff">确定兑换</span></el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import qs from "qs";
import Cookies from "js-cookie";
import axios from "axios";
import pay from "@/mixins/pay";
import VueQr from "vue-qr";
import exchange from "@/mixins/exchange";

export default {
  mixins: [pay, exchange],
  provide () {
    return {
      onShowLoginModal: this.onShowLoginModal,
      onExchangeIntegral: this.onExchangeIntegral,
      getUserInfo: this.getUserInfo,
      setActiveId: this.setActiveId,
    };
  },
  components: { VueQr },
  data () {
    return {
      orangeTheme:['member'],
      sso: this.$api.sso,
      BaseSSOUrl: this.$api.BaseSSOUrl,
      SSOUrl: this.$api.SSOUrl,
      location_host: this.$api.location_host,
      activeID: '0',
      searchVal: "",
      selectVal: "0",
      tabList: [],
      tabListMore: [],
      captchaPath: "", // 验证码图片地址
      showLoginModal: false,
      loginForm: {
        username: "",
        password: "",
        uuid: "",
        captcha: "",
        grant_type: "password",
      },
      load: {
        login: false,
      },
      loginFormRule: {
        username: [
          {
            required: true,
            message: "必填项不能为空",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "必填项不能为空",
            trigger: "blur",
          },
        ],
        captcha: [
          {
            required: true,
            message: "必填项不能为空",
            trigger: "blur",
          },
        ],
      },
      loginCallback: () => {
      }, // 组件登录的回调
    };
  },
  watch: {
    $route (val) {
      this.activeID = sessionStorage.getItem("activeID");
      if (val.name === "home") {
        this.activeID = '0';
      } else if (val.name === "my") {
        this.activeID = null;
      }
    },
    activeID (activeID) {
      console.log(activeID)
    }
  },
  mounted () {
    this.getChannelList();
    this.getUserInfo();
  },
  computed: {
    idOrangeTheme() {
      if(this.orangeTheme.indexOf(this.$route.name) != -1) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    toLogin () {
      // this.onShowLoginModal()
      window.location.href = this.BaseSSOUrl + this.SSOUrl + encodeURIComponent(this.location_host);
    },
    setActiveId (id) {
      this.activeID = id;
      sessionStorage.setItem("activeID", id);
    },
    onCommand (command) {
      if (!command) {
        return this.onLogout();
      }
      this.$router.push(command);
    },
    onLogout () {
      this.$post('/auth/oauth/logout').then(() => {
        Cookies.remove("access_token");
        this.$store.commit("user/onLogout");
        window.location.href = `${this.location_host}`;
      }).catch(res => {
        console.log('退出异常：', res);
        this.$message.error('网络错误')
      })
      // this.$router.go(0);
    },
    onSearch () {
      if (!this.searchVal) {
        return;
      }
      this.$router.push({
        name: "search",
        query: {
          searchVal: this.searchVal,
          channel: this.selectVal,
        },
      });
    },
    getChannelList () {
      this.$get(`${this.$api.apiUrl}/trading/api/channel`).then((res) => {
        if (res.data.length > 3) {
          this.tabListMore = res.data.slice(3);
          this.tabList = res.data.slice(0, 3);
        } else {
          this.tabList = res.data;
        }
      });
    },
    toPointsMall () {
      this.$router.push({ name: "points-mall" });
    },
    toVipDetail () {
      this.$router.push({ name: "member" });
    },
    clickHome () {
      this.$router.push({
        name: "home",
      });
      this.setActiveId('0')
    },
    handleClick (item) {
      this.$router.push({
        name: "channel",
        query: {
          channelName: item.channelName,
          channelVal: item.id,
        },
      });
      this.setActiveId(item.id)
    },
    // 与登录有关的方法 ↓↓↓↓↓↓↓
    onRegisteredModal () {
      window.open(`https://iam.pt.ouchn.cn/portal/#/RegisterStudent?goto=` + encodeURIComponent(this.location_host));
    },
    /**
     * 显示登录窗口
     * @param {Function} callback 登录成功后的回调
     */
    onShowLoginModal (callback) {
      this.getCaptcha();
      this.showLoginModal = true;
      if (typeof callback === "function") {
        this.loginCallback = callback;
      }
    },
    onHideModal () {
      this.loginForm = {
        username: "",
        password: "",
        uuid: "",
        captcha: "",
        grant_type: "password",
      };
      this.showLoginModal = false;
    },
    // 获取验证码
    getCaptcha () {
      this.loginForm.uuid = this.getUUID();
      this.captchaPath = `${this.$api.apiUrl}/auth/captcha?uuid=${this.loginForm.uuid}`;
    },
    onLogin () {
      this.load.login = true;
      this.$refs.loginForm.validate((valid) => {
        if (!valid) {
          return (this.load.login = false);
        }
        axios.post(`/auth/oauth/token`, qs.stringify(this.loginForm), {
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            Authorization: "Basic cmVucmVuaW86cmVucmVuaW8=",
          },
        }).then(({ data }) => {
          if (data.code !== 0) {
            this.getCaptcha();
            return this.$message.error(data.msg);
          }
          Cookies.set("access_token", data.access_token);
          this.onHideModal();
          this.$message.success("登录成功");
          this.getUserInfo();
          this.loginCallback();
          this.$router.go(0);
        }).catch(() => {
          this.$message.error("登录失败");
          this.getCaptcha();
        }).finally(() => {
          this.load.login = false;
        });
      });
    },
    getUUID () {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
        return (
            c === "x" ? (Math.random() * 16) | 0 : "r&0x3" | "0x8"
        ).toString(16);
      });
    },
    // 获取当前用户信息
    getUserInfo () {
      const token = Cookies.get("access_token");
      if (!token) return;

      axios.get(`/sys/user/info`).then(({ data: res }) => {
        if (res.code !== 0) {
          if (this.$route.path === "/my") {
            this.$router.replace("/");
          }
          Cookies.remove("access_token");
          return this.$message.error("请重新登录");
        }
        this.$store.commit("user/setUserInfo", res.data);
      });
    },
  },
};
</script>
<style lang="scss">
* {
  padding: 0;
  margin: 0;
  font-style: normal;
  font-variant-ligatures: normal;
  font-variant-caps: normal;
  font-variant-numeric: normal;
  font-variant-east-asian: normal;
  font-weight: normal;
  font-stretch: normal;
  font-size: 14px;
  // color: #333333;
  font-family: "PingFang SC", "Lantinghei SC", "Microsoft YaHei", "HanHei SC",
  "Helvetica Neue", "Open Sans", Arial, "Hiragino Sans GB", 微软雅黑, STHeiti,
  "WenQuanYi Micro Hei", SimSun, sans-serif;
  box-sizing: border-box;
}

.smnoprint div[title] {
  display: none !important;
}

div[onpositionupdate] {
  display: none;
}

header {
  height: 90px;
  width: 100%;
  padding: 0 40px;
  box-sizing: border-box;
  background-color: #00BBBD;
  position: sticky;
  top: 0;
  white-space: nowrap;
  z-index: 999;
  display: flex;
  &.theme-orange{
    background: linear-gradient(89.98deg, #EEBE6C 0.01%, #F2C881 99.98%);
  }

  .header-content {
    width: 100%;
    display: flex;
    align-items: center;

    .header-content-logo {
      cursor: pointer;
      width: 180px;
      height: 40px;
    }

    .header-content-tab {
      display: flex;
      align-items: center;

      &:before {
        content: ' ';
        width: 1px;
        height: 36px;
        background: #fff;
        opacity: .6;
        margin: 0 30px;
      }

      .header-content-tab-item {
        width: auto;
        margin-right: 24px;
        line-height: 22px;
        color: #fff;
        cursor: pointer;
        font-size: 16px;
        opacity: 0.8;
      }

      .header-content-tab-item.active {
        font-weight: bold;
        opacity: 1;
      }

      .header-content-tab-img {
        width: 12px;
        height: 14px;
        margin-right: 7px;
      }

      .header-content-tab-txt {
        margin-right: 30px;
        line-height: 14px;
        color: #3355ff;
        cursor: pointer;
      }
    }

    .header-content-img {
      width: 12px;
      height: 14px;
    }

    .header-content-txt {
      line-height: 14px;
      color: #24304d;
      cursor: pointer;
    }

    .header-content-vip {
      width: 14px;
      height: 14px;
      margin-right: 7px;
    }

    .header-content-viptxt {
      margin-right: 30px;
      line-height: 14px;
      color: #24304d;
      cursor: pointer;
    }

    .header-content-login {
      font-size: 15px;
      line-height: 18px;
      color: #333333;

      .el-divider {
        background-color: #333333;
      }
    }

    .el-input-group__prepend {
      border-radius: 22px 0 0 22px;
    }

    .el-input-group {
      width: 300px;
    }

    .el-input__inner {
      border-radius: 0 22px 22px 0;
      height: 32px;
      line-height: 32px;
    }


    .input-with-select .el-input-group__prepend {
      background-color: rgba(255, 255, 255, 0.2);
    }

    .el-select .el-input {
      width: 105px;
    }

    .el-input__icon {
      line-height: 32px;
    }

    // .el-tabs__nav-wrap:after{
    //     height: 0
    // }
  }
}

.grid {
  display: grid;
  grid-template-columns: 75px 75px 36px;
  grid-template-rows: 70px;
  grid-gap: 24px;

  > div {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

.input-with-select.el-input > .el-input__inner {
  border-left: none;
  border-color: #dcdfe6;
  padding-left: 10px;
  width: 188px;
}

.input-with-select > .el-input__suffix {
  right: 26px !important;
}

.input-with-select,
.el-input-group__prepend,
.el-select,
.el-input,
.el-input__inner {
  //text-align: center;
  display: block;
  color: #fff;
}

header .header-content .input-with-select .el-input-group__prepend {
  padding: 0 12px;
}

.content {
  // width: 1170px;
  margin: 0 auto;
  width: 100%;
  // background-color:lightcyan
}

footer {
  width: 100%;
  height: 200px;
  display: flex;
  justify-content: center;
  background-color: #151515;

  .footer-content {
    display: flex;
    justify-content: center;
    flex-direction: column;
    // background: #e0c7c7;
    width: 1170px;

    .footer-map {
      display: flex;
      align-items: center;

      img {
        width: 30px;
        height: 35px;
        margin-right: 20px;
      }

      span {
        margin-right: 10px;
      }
    }
  }
}

.el-dropdown-link {
  cursor: pointer;
  color: #fff;
  font-size: 16px;
  opacity: 0.8;
}

.el-dropdown-link.active {
  width: auto;
  color: #3355ff;
  font-weight: bold;

  &::after {
    content: "";
    width: 100%;
    border-bottom: 2px solid #3355ff;
    position: absolute;
    left: 0;
    bottom: -6px;
  }
}

.el-icon-arrow-down {
  font-size: 12px;
}

.g-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1000;
}

.g-modal__main {
  background: #fff;
  width: 460px;
  padding: 30px;
}

.g-modal__icon {
  width: 24px;
  height: 24px;
  vertical-align: middle;
  margin-top: -4px;
}

.g-modal__tab {
  font-size: 16px;
  color: #7c8394;
  align-items: center;
  line-height: 1;
}

.g-modal__tab.g-modal__tab--active {
  color: #24304d;
}

.g-modal__tab.g-modal__tab--active .g-modal__tab-line {
  background: #3355ff;
}

.g-modal__tab-line {
  width: 20px;
  height: 2px;
  background: transparent;
  border-radius: 2px;
  margin-top: 10px;
}

.mb-20 {
  margin-bottom: 20px;
}

div.g-model__captcha-input {
  display: inline-block;
  width: 245px;
}

.g-model__captcha {
  width: 135px;
  height: 36px;
  margin-left: 20px;
  cursor: pointer;
}

.g-model__captcha,
.g-model__captcha-input {
  vertical-align: top;
}

.g-modal__btn {
  width: 400px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  border-radius: 4px;
  font-size: 16px;
  outline: none;
  border: none;
  cursor: pointer;
}

.g-modal__btn.g-modal__btn--confirm {
  background: #3355ff;
  color: #fff;
}

.g-modal__btn.g-modal__btn--default {
  background: #fff;
  color: #3355ff;
}
</style>
<style scoped>
#app {
  min-width:1170px;
  min-height: 100vh;
}
.user-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  cursor: pointer;
  border: 1px solid #f1f1f1;
}

::v-deep .pay-dialog.el-dialog {
  box-sizing: border-box;
}

::v-deep .pay-dialog .el-dialog__body {
  padding: 0 24px 24px;
}

.pay-list {
  flex-wrap: wrap;
  min-height: 72px;
}

.pay {
  margin-top: 24px;
  width: 142px;
  height: 72px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  border-radius: 4px;
  line-height: 1;
  cursor: pointer;
  transition: 0.2s;
}

.pay:hover {
  background: #fafafa;
}

.pay.pay--active {
  border-color: #3355ff;
  background: #f5f7ff;
}

.pay-item {
  margin-right: 16px;
}

.pay-item.pay-item--3:nth-child(3n + 1) {
  margin-right: 0;
}

.pay-item.pay-item--4:nth-child(4n + 1) {
  margin-right: 0;
}

.pay__main {
  align-items: center;
}

.pay__icon {
  width: 32px;
  height: 32px;
  margin-right: 8px;
}

.pay__label {
  font-size: 14px;
}

.pay__tip {
  font-size: 12px;
  line-height: 14px;
  color: #999;
  margin-top: 10px;
}

.pay-integral {
  font-size: 14px;
  color: #000;
  margin-top: 12px;
  text-align: right;
}

.pay-integral__num {
  font-size: 24px;
  color: #f2994a;
}

.pay-modal-footer {
  text-align: right;
  margin-top: 16px;
}

.pay__warning {
  text-align: center;
  line-height: 14px;
  margin-top: 12px;
  height: 14px;
}

.pay__warning,
.el-icon-warning-outline {
  font-size: 14px;
  color: #eb5757;
}

.popover-title {
  font-size: 16px;
  color: #000;
}

.popover-cover {
  width: 144px;
  height: 144px;
  /*margin-top: 16px;*/
  /*margin-bottom: 16px;*/
  margin: 16px auto;
}

.popover-tip {
  font-size: 12px;
  color: #000;
}

/* 积分实体兑换 */
.p-my-address__tag {
  width: 56px;
  height: 18px;
  line-height: 18px;
  text-align: center;
  margin-left: 24px;
  background: #f2994a;
  border-radius: 2px;

  font-size: 12px;
  color: #fff;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 350px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

::v-deep .el-tabs__nav-wrap::after {
  height: 0;
}

::v-deep .el-radio.is-bordered {
  display: flex;
  align-items: center;
  padding: 16px;
  height: auto;
  margin-right: 0;
}

::v-deep .el-radio.is-bordered + .el-radio.is-bordered {
  margin-left: 0;
  margin-top: 16px;
}

.p-mall-dialog__order {
  padding: 24px;
  box-sizing: border-box;
}

.p-mall-dialog__order-cover {
  width: 140px;
  height: 110px;
  border-radius: 4px;
  margin-right: 24px;
}

.p-mall-dialog__order-main {
  line-height: 1;
  padding: 8px 0;
  box-sizing: border-box;
}

.p-mall-dialog__order-name {
  font-size: 16px;
  color: #333;
  margin-bottom: 16px;
}

.p-mall-dialog__order-desc {
  font-size: 14px;
  color: #bbb;
  line-height: 16px;
}

.p-mall-dialog__order-integral {
  align-items: center;
  margin-top: 16px;
}

.p-mall-dialog__order-integral-icon {
  width: 18px;
  height: 18px;
  margin-right: 4px;
}

.p-mall-dialog__order-integral-number {
  font-size: 18px;
  color: #f2994a;
}

.p-mall-dialog__order-integral-tip {
  font-size: 12px;
  color: #f2994a;
  margin-left: 4px;
}

.p-mall-dialog__order-tip {
  font-size: 14px;
  color: #666;
}

.p-mall-dialog__check-address {
  align-items: center;
  height: 48px;
  padding: 0 24px;
  justify-content: space-between;
  border-top: 1px dashed #eceded;
  border-bottom: 1px solid #eceded;
}

::v-deep .integral-dialog .el-dialog__body {
  padding: 0;
}

.p-mall-dialog__address-list {
  padding: 24px;
  height: 324px;
  overflow-y: auto;
}

.p-mall-dialog__address-user {
  line-height: 1;
  font-size: 14px;
  font-weight: bold;
  color: #333;
  display: inline-block;
}

.p-mall-dialog__address-phone {
  font-size: 12px;
  color: #666;
  margin-left: 16px;
  display: inline-block;
}

.p-mall-dialog__address-text {
  font-size: 12px;
  color: #666;
  margin-top: 8px;
}

.dialog-footer {
  height: 80px;
  line-height: 80px;
  border-top: 1px solid #eceded;
  text-align: right;
  padding: 0 24px;
}

.p-mall-dialog__empty {
  text-align: center;
}

.p-mall-dialog__empty-icon {
  width: 153px;
  height: 107px;
  margin-top: 50px;
  margin-bottom: 20px;
}

.p-mall-dialog__empty-text {
  font-size: 16px;
  color: #999;
  line-height: 16px;
}

.header-search {
  width: 255px;
  height: 32px;
  padding: 9px 8px 9px 16px;
  align-items: center;
  border-radius: 22px;
  background: rgba(255, 255, 255, 0.2);
}
.header-search__select {
  width: 70px;
  flex-shrink: 0;
  margin-right: 14px;
}
.header-search__input {
  background: transparent;
  border: none;
  color: #fff;
  font-size: 14px;
  width: 100%;
  box-sizing: border-box;
}
.header-search__input::placeholder {
  color: rgba(255, 255, 255, .4);
}
.header-search__icon {
  color: #fff;
  padding: 8px;
  cursor: pointer;
}
.header-menus__menu {
  font-size: 14px;
  line-height: 14px;
  color: #fff;
  margin-left: 25px;
  cursor: pointer;
}
.header-menus__menu-icon {
  width: 14px;
  height: 14px;
  margin-right: 4px;
}

.footer__logo {
  width: 154px;
  height: 34px;
  margin-top: 50px;
  margin-bottom: 45px;
}
.footer-copyright {
  font-size: 14px;
  color: #fff;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 55px;
  opacity: 0.8;
}
.footer-copyright a {
  color: #fff;
  display: flex;
  align-items: center;
  line-height: 1;
}
.police {
  width: 16px;
  height: 16px;
  margin-right: 4px;
}
.footer__split {
  width: 1px;
  height: 16px;
  background: #fff;
  flex-shrink: 0;
  margin: 0 18px;
}
</style>
